import { useMemo } from 'react';
import { useSellerData, SellerPageFederatedSeller } from '@fiverr-private/seller_pages_toolbox';
import { convertMillisecondsToSeconds } from './useWorkExperiencesData.utils';

export const useWorkExperiencesData = () => {
    const { workExperiences: rawWorkExperiences } = useSellerData(selectSellerSlice);

    const workExperiences = useMemo(
        () =>
            rawWorkExperiences.map((experience) => ({
                ...experience,
                startDate: convertMillisecondsToSeconds(experience.startDate),
                endDate: convertMillisecondsToSeconds(experience.endDate),
            })),
        [rawWorkExperiences]
    );

    const showWorkExperience = workExperiences && workExperiences.length > 0;

    return {
        workExperiences,
        showWorkExperience,
    };
};

function selectSellerSlice(seller: SellerPageFederatedSeller) {
    return {
        workExperiences: seller.workExperiences?.nodes || [],
    };
}
